import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../../utils/http";

const initialState = {
  isLoading: false,
  creatorsData: [],
  error: null,
};

export const getAllCreatorsData = createAsyncThunk(
  "application/getCreatorsData",
  async (payload, thunkAPI) => {
    try {
      const response = await http?.get(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/get-all-creators${
          payload?.searchVal ? `?searchVal=${payload?.searchVal}` : ""
        }`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const freezeCreator = createAsyncThunk(
  "application/freezeCreator",
  async (id, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/freeze-user/${id}`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const unfreezeCreator = createAsyncThunk(
  "application/unfreezeCreator",
  async (id, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/unfreeze-user/${id}`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteCreator = createAsyncThunk(
  "application/deleteCreator",
  async (id, thunkAPI) => {
    try {
      const response = await http?.post(
        `${process.env.REACT_APP_API_SIDEKICK_BASE_URL}/delete-user/${id}`
      );
      return thunkAPI.fulfillWithValue(response?.data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const creatorsSlice = createSlice({
  name: "creators",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllCreatorsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCreatorsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.creatorsData = action.payload;
      })
      .addCase(getAllCreatorsData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(freezeCreator.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(freezeCreator.fulfilled, (state, action) => {
        state.isLoading = false;
        state.creatorsData = action.payload;
      })
      .addCase(freezeCreator.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(unfreezeCreator.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(unfreezeCreator.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(unfreezeCreator.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(deleteCreator.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCreator.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteCreator.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default creatorsSlice.reducer;
